import React from 'react';

import classes from './styles.module.scss';

export default function CompanyAvatar({ companyName, size = 60 }) {
  return (
    <div
      className={classes.CompanyAvatar}
      style={{ width: size, height: size }}
    >
      {companyName && companyName[0]}
      {companyName && companyName[companyName.length - 1]}
    </div>
  );
}
